export default __webpack_public_path__ + "static/media/lighthouse-circle.60e2e81d.png";